module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('error-page', {
    attrs: {
      "code": "502",
      "description": _vm.description
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a45bf2e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/errors/502.vue
// module id = 2661
// module chunks = 0